import React from 'react'
import './page-title.css'

const PageTitle = ({Title, Description}) => {
    return (
        <div className='page'>
            <p className='page-title app-title'>{Title}</p>
            <p className='page-description app-text'>{Description}</p>
        </div>
    )
}

export default PageTitle